export default [{
    path: '/app/request',
    name: 'request',
    redirect: {
        name: 'dashboard'
    },
    component: () => import('../../../components/dashboard/client/RequestsComponent.vue'),
    children: [{
            path: '/app/request/deposit/:portfolio?',
            name: 'requests.deposit',
            component: () => import('../../../components/dashboard/client/requests/DepositComponent.vue'),
            meta: {
                allowedUsers: ['client']
            }
        },
        {
            path: '/app/request/withdraw',
            name: 'requests.withdraw',
            component: () => import('../../../components/dashboard/client/requests/WithdrawComponent.vue'),
            meta: {
                allowedUsers: ['client']
            }
        },
        {
            path: '/app/request/trade-fixed-income/:portfolio',
            name: 'requests.trade-fixed-income',
            component: () => import('../../../components/dashboard/client/requests/TradeFixedIncomeComponent.vue'),
            meta: {
                allowedUsers: ['client']
            }
        }
    ]
}]
